<template>
  <default>
    <div class="cust-travel-wrap">
      <travel-finalization-page channel="customer" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import TravelFinalizationPage from '@/components/travel/TravelFinalizationPage';

export default {
  name: 'CustomerTravelFinalization',
  components: { Default, TravelFinalizationPage },
  props: {
    quoteId: { type: [String, Number], default: null },
  },
  metaInfo: { title: 'Travel Insurance — Complete' },
};
</script>

<style src="@/assets/css/customer-travel.css"></style>
